module.exports = __webpack_public_path__ + "static/media/firma_limed.de0bf360.png";